import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import G from '../assets/images/gold1.png';
import S from '../assets/images/siler1.png';
import "./CardStyles.css";

const forms = [
    {
        title: "Gold Pack - Rs. 300",
        description: "Tech (2), Non-Tech (2), Project Presentation, E-Sports",
        image: G,
        link: "",
    },
    {
        title: "Silver Pack - Rs. 250",
        description: "Tech (2), Non-Tech (2), E-Sports",
        image: S,
        link: "",
    },
];

const CardComponent = () => {
    return (
        <section className="tin2">
            <h1 className="tin">Explore our Combo Packs</h1>
            <div className="container d-flex justify-content-center flex-wrap mt-5">
                {forms.map((form, index) => (
                    <div
                        key={index}
                        className="card-container"
                        onClick={() => window.open(form.link, "_blank")}
                    >
                        <img src={form.image} className="card-img" alt={form.title} />
                        <div className="overlay">
                            <div className="overlay-content">
                                <div className="overlay-title">{form.title}</div>
                                <div className="overlay-description">{form.description}</div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default CardComponent;